// extracted by mini-css-extract-plugin
module.exports = {"varSpBase":"1rem","varSpDown2":"0.5rem","container":"container--3860c","caption":"caption--2c2fc"};